/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";

/* components */
import formWrapper from "../../shared/Form";
import {
	TextInput,
	SelectInput,
	PublishAtPicker,
	PagePicker,
	ThemePicker,
	Tags,
	TopicsPicker,
} from "../../shared/Forms";

class ExperienceForm extends Component {
	componentDidMount() {
		if (!this.props.hasFormApi) {
			this.props.getFormApi(this.props.formApi);
		}
	}

	render() {
		const { cultures, isUpdateForm } = this.props;
		let data = [];
		cultures.forEach(culture => {
			data.push({ key: culture.code, value: culture.code, label: culture.name });
		});

		return (
			<React.Fragment>
				<TextInput field="name" id="name" placeholder="Name" autocomplete="off" isRequired={true} />
				{data.length > 0 && (
					<SelectInput field="culture" id="culture" values={data} placeholder="Culture" isRequired={true} />
				)}
				<PublishAtPicker field="publishAt" id="publishAt" placeholder="Date and Time to Publish Experience" />
				{isUpdateForm && (
					<div>
						<PagePicker field="homePageId" id="homePageId" placeholder="Homepage" />
					</div>
				)}
				<ThemePicker field="primaryThemeId" id="primaryThemeId" placeholder="Default Theme" />
				<Tags field="accessCodes" id="accessCodes" placeholder="Access Codes" allowNew />
				<TopicsPicker
					field="firstVisitTopics"
					id="firstVisitTopics"
					placeholder="Topics on First Visit"
					helperText="Automatically subscribed-to topics"
				/>

				<div className="btn btn-success" onClick={() => this.props.submitForm(true)}>
					{this.props.buttonLabel}
				</div>
			</React.Fragment>
		);
	}
}

ExperienceForm.propTypes = {
	actionType: PropTypes.string,
	buttonLabel: PropTypes.string,
	cultures: PropTypes.array,
	formApi: PropTypes.object,
	getFormApi: PropTypes.func,
	hasFormApi: PropTypes.bool,
	id: PropTypes.string,
	isUpdateForm: PropTypes.bool,
	showExtraFields: PropTypes.bool,
	submitForm: PropTypes.func,
	values: PropTypes.object,
};

export default formWrapper(ExperienceForm);
